import * as React from 'react';

import { RootState } from '../store';

import { Dispatch, Action } from 'redux';
import { UPDATE_FORM, SUBMIT_LOGIN, TOGGLE_CHECKOUT } from '../store/login';
import { returntypeof } from '../helper';
import { connect } from 'react-redux';
import { Photo, Brick, Group, TOGGLE_SELECT_PHOTO, OPEN_PHOTO } from '../store/photos';

const mapStateToProps = (state: RootState, props: PhotoProps) => ({
    ticket: state.login.ticket,
    brick: props.brick,
    webshop: state.webshop,
    photo: state.photo,
    payment_gateway: state.login.payment_gateway,
    rendition_type: state.login.rendition_type,
    login: state.login,
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
    onChange: (field: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
        dispatch({
            type: UPDATE_FORM,
            field: field,
            value: event.currentTarget.value
        })
    },
    onSubmit: () => {
        dispatch({ type: SUBMIT_LOGIN })
    },

    toggleCheckout: (id: string) => {
        dispatch({ type: TOGGLE_CHECKOUT, id })
    },
    onSelect: (id: string) => (e?: React.MouseEvent<any>) => {
        if (e != undefined) {
            e.stopPropagation();
            e.preventDefault();
        }

        dispatch({ type: TOGGLE_SELECT_PHOTO, id });
    },
    onOpen: (id: string) => () => {
        dispatch({ type: OPEN_PHOTO, id });
    }
});

const stateProps = returntypeof(mapStateToProps);
const dispatchProps = returntypeof(mapDispatchToProps);

type Props = typeof stateProps & typeof dispatchProps;


interface PhotoProps {
    brick: Photo | Group,
}

interface PhotoState {
    loaded: boolean,
    width: number,
    height: number
}

class PhotoBrick extends React.Component<Props, PhotoState> {

    constructor(props: Props) {
        super(props);

        this.state = {
            loaded: false,
            width: 1,
            height: 1
        }
    }

    onImageLoad = (e: React.SyntheticEvent<HTMLImageElement, Event>) => {

        this.setState({
            width: e.currentTarget.naturalWidth,
            height: e.currentTarget.naturalHeight,
            loaded: true
        });

    }

    onVideoLoad = (e: React.SyntheticEvent<HTMLVideoElement, Event>) => {
        this.setState({
            width: e.currentTarget.videoWidth,
            height: e.currentTarget.videoHeight,
            loaded: true
        });
    }

    onDownloadClick = (id: string) => (e: React.MouseEvent<any>) => {
        e.stopPropagation();
        e.preventDefault();
        if ((this.props.payment_gateway != undefined || this.props.login.paypal_gateway != undefined) && !this.props.webshop.orders.has(id) && this.props.login.webshop) {
            this.props.toggleCheckout(id);

        } else {

            let ticket = encodeURIComponent(this.props.ticket || "");

            window.open(`/api/v1/download/original/${id}?sbpportal-ticket=${ticket}`, "_blank");
        }

    }

    onRef = (e: HTMLVideoElement | HTMLImageElement | null) => {

        let ticket = encodeURIComponent(this.props.ticket || "");

        if (e != undefined && this.props.brick.type == "photo") {

            let brick = this.props.brick;


            let observer = new IntersectionObserver((entries) => {

                entries.filter(entry => entry.isIntersecting)
                    .forEach(entry => {
                        if (!this.state.loaded) {
                            e.src = `/api/v1/preview/${this.props.rendition_type}/${brick.id}?sbpportal-ticket=${ticket}`;
                        }

                    });
            });

            observer.observe(e);

        }
    }

    renderControls = (brick: Photo) => {

        if (this.state.loaded) {

            let downloadBtn;
            if (this.props.webshop.orders.has(brick.id)) {
                downloadBtn = <div className="actions">
                    <button className="btn btn-basket" onClick={this.onDownloadClick(brick.id)}><img src="/assets/icons/download_green.png" height="20px" width="auto"></img></button>
                </div>
            } else {
                if (this.props.photo.selected.has(brick.id)) {
                    downloadBtn = <div className="actions">
                        <button className="btn btn-primary" onClick={this.props.onSelect(brick.id)}><img src="/assets/icons/add-cart.png" height="20px" width="auto"></img></button>
                    </div>
                }
                else {
                    downloadBtn = <div className="actions">
                        <button className="btn btn-link" onClick={this.props.onSelect(brick.id)}><img src="/assets/icons/add-cart-blue.png" height="20px" width="auto"></img></button>
                    </div>
                }

                if (this.props.login.webshop == false) {
                    downloadBtn = <div className="actions">
                        <button className="btn btn-basket" onClick={this.onDownloadClick(brick.id)}><img src="/assets/icons/download_green.png" height="20px" width="auto"></img></button>
                    </div>
                }
            }

            return (
                downloadBtn
            )
        } else {
            return <div className="loading loading-lg" />;
        }

    }


    public render() {

        let brick_class = "gallery-brick";

        if (this.state.height > this.state.width) {
            brick_class += " tall";
        } else {
            brick_class += " wide";
        }

        let brick = this.props.brick;

        if (brick.type == "photo") {
            let img_class = "gallery-img";

            if (!this.state.loaded) {
                img_class += " img-loading";
            }

            let elem;

            if (brick.preview_type.some(val => val == "video")) {
                elem = <video preload="auto" ref={this.onRef} onLoadedMetadata={this.onVideoLoad} className="img-fade" />
            } else {
                elem = <img ref={this.onRef} onLoad={this.onImageLoad} className="img-fade" />
            }

            return (
                <div className={brick_class}>
                    <div className={img_class}>
                        {elem}
                        <div className="brick-overlay" onClick={this.props.onOpen(brick.id)}>
                            {this.renderControls(brick)}
                        </div>
                    </div>
                </div>
            )
        }

        if (brick.type == "group") {
            return (
                <div className="gallery-brick medium">
                    <div className="invert">
                        <div className="invert-content">
                            Year
                            <h1>{brick.value}</h1>
                        </div>
                    </div>
                </div>
            )
        }


    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PhotoBrick);